import PinPadStepperDialog from './PinPadStepperDialog';

export default PinPadStepperDialog;
